// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"beta"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 15.2941L6 9.5L19 4V15.2941ZM19 15.2941V20H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BetaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'beta',
    ref,
    icon: element,
  },
));

BetaIcon.displayName = 'BetaIcon';

export default BetaIcon;
